<template>
  <ModatechWidget v-if="page" :key="page.key" :type="page.type" :page-data="page.data" />
</template>
<script>
import ModatechWidget from './ModatechWidget.vue'
export default {
  components: {ModatechWidget},
  computed: {
    page() {
      const route = this.$route
      const path = '/' + route.path.split('/').filter(Boolean).join('/') + (route.path === '/' ? '' : '/')
      const page = {key: route.path, type: 'custom', data: {code: path}}
      switch (route.name) {
        case 'detail': return null
        case 'main': page.type = 'main'; break
        case 'category': {
          const section = this.$store.getters.section
          if (/^[1-9][0-9]*$/.test(String(route.params.id))) {
            if (!this.$store.getters.productsLoaded || String(section?.id) !== String(route.params.id)) { return null }
            page.type = 'category'
            page.data = {category_id: String(section.id)}
          }
          break
        }
        case 'basket': page.type = 'cart'; break
        case 'favorite': page.type = 'favorites'; break
        case 'lookbooks':
          page.type = 'inline'
          page.data = {payload: typeof route.query.payload === 'string' ? route.query.payload : ''}
          page.key += ':' + page.data.payload
          break
        case 'notfound': page.data = {code: '404'}; break
      }
      return page
    }
  }
}
</script>
